const pageNameKey = "tileDrawerModal";

export const tileDrawerModalEn = {
  [pageNameKey]: {
    title: "Blueprint Dashboard Tiles",
    create: "Create",
    close: "Close",
    createNewTile: "Create New Tile",
    editTile: "Edit Tile",
  },
};

export const tileDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Blocos do dashboard do blueprint",
    create: "Criar",
    close: "Fechar",
    createNewTile: "Criar novo bloco",
    editTile: "Editar bloco",
  },
};

export const tileDrawerModalDe = {
  [pageNameKey]: {
    title: "Blueprint-Dashboard-Kacheln",
    create: "Erstellen",
    close: "Schließen",
    createNewTile: "Neue Kachel erstellen",
    editTile: "Kachel bearbeiten",
  },
};

export const tileDrawerModalZhHans = {
  [pageNameKey]: {
    title: "蓝图仪表板瓷砖",
    create: "创建",
    close: "关闭",
    createNewTile: "创建新瓷砖",
    editTile: "编辑瓷砖",
  },
};

export const tileDrawerModalIt = {
  [pageNameKey]: {
    title: "Schede del dashboard Blueprint",
    create: "Crea",
    close: "Chiudi",
    createNewTile: "Crea nuova scheda",
    editTile: "Modifica scheda",
  },
};

export const tileDrawerModalEs = {
  [pageNameKey]: {
    title: "Mosaicos del panel de Blueprint",
    create: "Crear",
    close: "Cerrar",
    createNewTile: "Crear nuevo mosaico",
    editTile: "Editar mosaico",
  },
};

export const tileDrawerModalNl = {
  [pageNameKey]: {
    close: "Sluiten",
    create: "Aanmaken",
    createNewTile: "Nieuwe tegel aanmaken",
    editTile: "Tegel bewerken",
    title: "Blueprint-dashboardtegels",
  },
};

export const tileDrawerModalTr = {
  [pageNameKey]: {
    close: "Kapat",
    create: "Yaratmak",
    createNewTile: "Yeni Döşeme Oluştur",
    editTile: "Döşemeyi Düzenle",
    title: "Blueprint Kontrol Paneli Döşemeleri",
  },
};
